module.exports = __webpack_public_path__ + "img/fitness-behance-2.2632aa88.jpg";